export default __webpack_public_path__ + "static/art & science_logo-65122b79f8b092a3d894399b60cdff36.png";